import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en_common from './en/common.json';
import en_force from './en/force.json';
import en_loginmessage from './en/loginmessage.json';
import en_message from './en/message.json';
import ja_common from './ja/common.json';
import ja_loginmessage from './ja/loginmessage.json';
import ja_message from './ja/message.json';

i18next.on('languageChanged', lng => {
	// tslint:disable-next-line:no-console
	console.debug('languageChanged', lng);
	document.documentElement.setAttribute('lang', lng);
});

i18next.use(LanguageDetector).init({
	defaultNS: 'common',
	detection: {
		caches: ['cookie'],
		cookieOptions: { path: '/', sameSite: 'strict' },
		order: ['cookie'],
	},
	fallbackLng: 'ja',
	ns: ['common', 'message'],
	react: {
		wait: true,
	},
	resources: {
		en: {
			common: en_common,
			force: en_force,
			loginmessage: en_loginmessage,
			message: en_message,
		},
		ja: {
			common: ja_common,
			loginmessage: ja_loginmessage,
			message: ja_message,
		},
	},
});

export default i18next;



// WEBPACK FOOTER //
// ./src/resources/i18n.ts